import { render, staticRenderFns } from "./PatientSearchResultModal.vue?vue&type=template&id=4ecdbc6a&"
import script from "./PatientSearchResultModal.vue?vue&type=script&lang=js&"
export * from "./PatientSearchResultModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientSearchResultModal.vue?vue&type=style&index=0&id=4ecdbc6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports